import React from "react";

export default function FILTVTuningIn({ channel }) {
    return (
        <div className="w-full aspect-video flex flex-col items-center justify-center bg-zinc-900 text-center px-6">
            <div className="text-4xl mb-2 animate-pulse">📡</div>
            <div className="text-sm font-semibold text-zinc-300">
                Tuning in{channel ? ` to LCN ${channel.lcn}` : ""}...
            </div>
        </div>
    );
}